




























import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import _ from "lodash";
import CommonSelectOwnerMixin from "@/mixins/components/CommonSelectOwnerMixin";
import Owner from "@/model/cospirit-api/Owner";
import CsTreeSelect from "@/components/miscellaneous/CsTreeSelect.vue";

const components = {
    CsTreeSelect,
};
@Component({ components })
export default class SelectMultipleOwner extends Mixins(CommonSelectOwnerMixin) {
    @Prop({type: Array, default: null}) private value!: string[] | null;
    @Prop(Object) private entity!: any;
    @Prop(Boolean) private disable!: boolean;
    @Prop({default: Infinity}) private limit!: number;
    @Prop(String) private fromOwnerUuid!: string;
    @Prop(Array) private showParentsAmongUuids!: string[];
    @Prop({type: Boolean, default: true}) private filteredByRights!: boolean;

    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;

    private selectedOwnerUuid: string[] = [];

    @Watch("value", { immediate: true }) private updateValue() {
        this.selectedOwnerUuid = this.value ? this.value : [];
    }

    @Watch("ownerUuid") private changeOwner() {
        this.setAvailableOwners();
    }

    @Watch("masterOwners") private updateOwners() {
        this.setAvailableOwners();
    }

    @Watch("entity.hierarchyOwners") private updateSelected(): void {
        this.selectedOwnerUuid = [];
        _.forEach(this.entity.hierarchyOwners, (value, idx) => {
            this.selectedOwnerUuid.push(value.uuid);
        });
    }

    private updateSelectedOwner(selectedOwnerUuid: string[]): void {
        this.selectedOwnerUuid = selectedOwnerUuid;
        this.$emit("update-selected-owners", this.selectedOwnerUuid);
    }

    private mounted(): void {
        _.forEach(this.entity.hierarchyOwners, (value, idx) => {
            this.selectedOwnerUuid.push(value.uuid);
        });

        const first = _.first(this.masterOwners);
        if (0 === this.selectedOwnerUuid.length && 1 === this.masterOwners.length && first) {
            this.selectedOwnerUuid = [first.uuid];
            this.$emit("update-selected-owners", this.selectedOwnerUuid);
        }
        this.setAvailableOwners();
    }

    private setAvailableOwners() {
        this.filteredOwners = this.filterOwners(_.clone(this.masterOwners));
        if (this.ownerList) {
            this.availableOwners = this.ownerList;
            return;
        }
        this.setChildren(this.masterOwners);
        // we build options from children instead of parents,
        // this allows to only show options that have result in the database ( ownerList prop)
        this.availableOwners = Object.values(this.children).map((owner) => {
            return {
                uuid: owner.uuid,
                fullName: _.get(owner, "fullName", ""),
            };
        });

        if (1 === this.availableOwners.length) {
            // Si la liste ne contient plus qu'une option après filtrage,
            // il faut forcer la mise à jour avec la seule option.
            const firstOption = _.first(this.availableOwners);
            if (firstOption) {
                this.updateSelectedOwner([firstOption.uuid]);
            }
        }
        this.$emit("number-options-changed", this.availableOwners.length);
    }

    protected setChildren(owners: Owner[]) {
        _.forEach(owners, (owner) => {
            this.addChildrenAndParents(owner);
        });
    }

    private getLimitText(count: number) {
        return "+ " + count;
    }


    private isAncestorsSearch(): boolean {
        return _.isArray(this.showParentsAmongUuids) && !_.isEmpty(this.showParentsAmongUuids);
    }

    private filterOwners(owners: Owner[]): Owner[] {
        const filteredOwners = this.filterOwnersBy(owners);

        if (this.isAncestorsSearch()) {
            return this.searchParentsAmong(filteredOwners, this.showParentsAmongUuids);
        }

        return filteredOwners.sort((a: Owner, b: Owner) => {
            if (!a.left || !b.left) {
                return 0;
            }
            return a.left - b.left;
        });
    }

    private filterOwnersBy(owners: Owner[]): Owner[] {
        const fromOwner = owners.find((owner: Owner) => {
            return owner.uuid === this.fromOwnerUuid;
        });

        const leftFromOwner = fromOwner?.left || -1;
        const rightFromOwner = fromOwner?.right || -1;
        return owners.filter(
            (owner: Owner) => {
                this.addChildrenAndParents(owner);
                const filterByOwnerUuid = this.fromOwnerUuid ?
                    (owner.left ? owner.left : 0) >= leftFromOwner &&
                    (owner.right ? owner.right : 0) <= rightFromOwner :
                    true;
                const filterByDepthRights = this.filteredByRights ?
                    !_.has(owner, "hasRights") || 1 === _.get(owner, "hasRights", false) :
                    true;
                return filterByOwnerUuid && filterByDepthRights;
            }
        );
    }

    private searchParentsAmong(owners: Owner[], showNearestParentAmongUuids: string[]) {
        const result: Owner[] = [];
        showNearestParentAmongUuids.forEach((uuid: string) => {
            const possibleAncestor = owners.find((o: Owner) => o.uuid === uuid);
            if (!possibleAncestor) {
                return;
            }
            const mustBeShow = owners.some((owner: Owner) => {
                return _.has(owner, "left")
                    && _.has(owner, "right")
                    && _.has(possibleAncestor, "left")
                    && _.has(possibleAncestor, "right")
                    && _.get(owner, "left", 0) >= _.get(possibleAncestor, "left", 0)
                    && _.get(owner, "right", 0) <= _.get(possibleAncestor, "right", 0);
            });
            if (mustBeShow) {
                result.push(possibleAncestor);
            }
        });

        return result;
    }
}

